import { TopCitiesResponse } from 'store/api/api.types';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { TopDestination } from 'core/type/ActivitiesTopDestinations.types';
import { isQueryLoading } from 'store/api/apiUtils';
import { measureTopCitiesApiResponse } from 'store/api/measurements/cityPageMeasurements';

export const getTopCities = (response: TopCitiesResponse, pageTypeId: number, config: BootstrapConfig): TopDestination[] => {
    if (!isQueryLoading(response)) {
        measureTopCitiesApiResponse(response, pageTypeId, config);
    }
    if (response.isSuccess) {
        const topCities = response.data?.filter((city) => city.cityId !== config.geo?.cityId);
        return topCities || [];
    }
    return [];
};
